import { useNavigate } from "react-router-dom";
interface SimpleCardProps {
  urlImage: string;
  title: string;
  className?: string;
  projectId?: number;
}
const SimpleCard = ({ ...props }: SimpleCardProps) => {
  const navigate = useNavigate();

  return (
    <figure
      {...props}
      title=""
      className={`takaful--simple-card ${props.className ?? ""}`}
      onClick={() =>
        navigate(`${`project/${props.projectId}`}`, {
          state: { type: "المشاريع" },
        })
      }
    >
      <img className="main-image" src={props.urlImage} alt="" />
      <h6>{props.title}</h6>
    </figure>
  );
};

export default SimpleCard;
